import { EventMarker, Session } from '../timelineUtils';

export const mockSessions: Session[] = [
  {
    id: 'session-001',
    date: '2025-04-12',
    dataSource: 'peach',
    sessionType: 'Steady State 14km',
    avgPower: 268,
    maxPower: 332,
    startTime: '2025-04-12T06:15:00-04:00',
    endTime: '2025-04-12T07:45:00-04:00',
  },
  {
    id: 'session-002',
    date: '2025-04-13',
    dataSource: 'peach',
    sessionType: '4 x 1500m @ 32spm',
    avgPower: 292,
    maxPower: 360,
    startTime: '2025-04-13T06:05:00-04:00',
    endTime: '2025-04-13T07:25:00-04:00',
  },
  {
    id: 'session-003',
    date: '2025-04-13',
    dataSource: 'rowhero',
    sessionType: '10k Erg @ 1:52',
    avgPower: 305,
    maxPower: 380,
    startTime: '2025-04-13T17:10:00-04:00',
    endTime: '2025-04-13T17:55:00-04:00',
  },
  {
    id: 'session-004',
    date: '2025-04-15',
    dataSource: 'rowhero',
    sessionType: '4 x 8min Threshold',
    avgPower: 298,
    maxPower: 365,
    startTime: '2025-04-15T16:40:00-04:00',
    endTime: '2025-04-15T17:50:00-04:00',
  },
  {
    id: 'session-005',
    date: '2025-04-17',
    dataSource: 'peach',
    sessionType: 'Race Pace Simulation',
    avgPower: 315,
    maxPower: 392,
    startTime: '2025-04-17T06:10:00-04:00',
    endTime: '2025-04-17T07:20:00-04:00',
  },
  {
    id: 'session-006',
    date: '2025-04-19',
    dataSource: 'rowhero',
    sessionType: '2k Test',
    avgPower: 332,
    maxPower: 415,
    startTime: '2025-04-19T16:30:00-04:00',
    endTime: '2025-04-19T16:46:30-04:00',
  },
  {
    id: 'session-007',
    date: '2025-04-20',
    dataSource: 'peach',
    sessionType: 'Recovery Row 8km',
    avgPower: 215,
    maxPower: 275,
    startTime: '2025-04-20T07:00:00-04:00',
    endTime: '2025-04-20T08:05:00-04:00',
  },
  {
    id: 'session-008',
    date: '2025-05-01',
    dataSource: 'peach',
    sessionType: 'Race: Mid-Atlantic Invite',
    avgPower: 348,
    maxPower: 428,
    startTime: '2025-05-01T09:30:00-04:00',
    endTime: '2025-05-01T10:00:00-04:00',
  },
];

export const mockEvents: EventMarker[] = [
  {
    id: 'event-001',
    startDate: '2025-04-05',
    label: 'Spring Training Camp',
    category: 'Camp',
  },
  {
    id: 'event-002',
    startDate: '2025-04-23',
    label: 'Head of the Charles Review',
    category: 'Review',
  },
  {
    id: 'event-003',
    startDate: '2025-05-02',
    label: 'NCAA Selection Deadline',
    category: 'Compliance',
  },
  {
    id: 'event-004',
    startDate: '2025-10-17',
    endDate: '2025-10-19',
    label: 'Head of the Charles Regatta',
    category: 'Regatta',
  },
];
